import VueRouter from "vue-router";
import toast from "./js/toast";
import userManager from "@amsom-habitat/user-manager";
import store from "./store";

const mustBeUnAuthenticated = (to, from, next) => {
    if (store.getters['user/isValid']) {
        console.log("Utilisateur déjà connecté");
        next({name: 'home'})
    } else {
        next();
    }
};
const mustBeAuthenticated = async (to, from, next) => {
    // Aucun logout dans ce garde : le cookie de session est partagé par tous les outils du
    // domaine, le supprimer déconnecterait aussi le cockpit, cally2, etc. goToLoginPage()
    // purge de lui-même un token dont l'expRefresh est dépassé.
    if (!userManager.isLogged()) {
        userManager.goToLoginPage();
        return;
    }

    if (!store.getters['user/getRoles'].length) {
        alert("Il semble que vous n'ayez pas les droits nécessaires pour accéder à cet outil. Veuillez contacter l'informatique.");
        return;
    }

    // Absence de code Tiers : problème propre à cet outil, on informe sans toucher à la session.
    if (!store.getters['user/getCodeTiers']) {
        alert("Utilisateur sans code Tiers, contacter l'informatique");
        toast.showToast('info', "Utilisateur sans code Tiers, contacter l'informatique", 5000);
        return
    }

    next();
};

const routes = [
    {
        path: '/login',
        component: require('./pages/LoginPage').default,
        beforeEnter: mustBeUnAuthenticated,
        name: 'login'
    },
    {
        path: '/profile', component: require('./pages/UserProfile').default, name: 'profile',
        beforeEnter: mustBeAuthenticated
    },

    {
        path: '/creationsollicitation',
        component: require('./pages/CreationSollicitation').default,
        name: 'creationrecla',
        beforeEnter: mustBeAuthenticated,
        children: [
            {
                path: 'categories',
                component: require('./components/creationsollicitation/Categories').default,
                name: 'categories'
            },
            {
                path: 'types',
                component: require('./components/creationsollicitation/Types').default,
                name: 'types'
            },
            {
                path: 'natures',
                component: require('./components/creationsollicitation/Natures').default,
                name: 'natures'
            },
            {
                path: 'motifs',
                component: require('./components/creationsollicitation/Motifs').default,
                name: 'motifs'
            },
            {
                path: 'adresse',
                component: require('./components/creationsollicitation/Adresse').default,
                name: 'adresse'
            },
            {
                path: 'formulaire',
                component: require('./components/creationsollicitation/FormulairePostSollicitation').default,
                name: 'formulaire'
            },
            {
                path: 'formulaire/:identree/:motif',
                component: require('./components/creationsollicitation/FormulairePostSollicitation').default,
                name: 'formulaire-with-params'
            }
        ]
    },

    {
        path: '/suivisollicitation', component: require('./pages/SuiviSollicitation').default, name: 'suivirecla',
        beforeEnter: mustBeAuthenticated,
        children: [
            {
                path: 'liste',
                component: require('./components/suivisollicitation/fichesuivisollicitation/ListeSollicitations').default,
                name: 'liste'
            },
            {
                path: 'patrimoine',
                component: require('./components/suivisollicitation/fichesuivisollicitation/ListeSollicitations').default,
                name: 'patrimoine'
            },
            {
                path: 'relance',
                component: require('./components/suivisollicitation/fichesuivisollicitation/ListeSollicitations').default,
                name: 'relance'
            },
            {
                path: 'all',
                component: require('./components/suivisollicitation/fichesuivisollicitation/ListeSollicitations').default,
                name: 'all'
            },
            {
                path: 'fichesuivi/:id',
                component: require('./components/suivisollicitation/fichesuivisollicitation/FicheSuiviSollicitation').default,
                name: 'fichesuivi'
            },
            {
                path: 'creation',
                component: require('./pages/CreationSuiviSollicitation').default,
                name: 'creationsuivi',
                children: [
                    {
                        path: 'evenements',
                        component: require('./components/creationsuivisollicitation/Evenements').default,
                        name: 'evenements'
                    },
                    {
                        path: 'actions',
                        component: require('./components/creationsuivisollicitation/Actions').default,
                        name: 'actions'
                    },
                    {
                        path: 'formulairesuivi',
                        component: require('./components/creationsuivisollicitation/FormulairePostSuiviSollicitation').default,
                        name: 'formulairesuivi'
                    },
                    {
                        path: 'facturerbadge',
                        component: require('./components/creationsuivisollicitation/FacturerBadge').default,
                        name: 'facturerbadge'
                    }
                ]
            },
            {
                path: 'cloturer',
                component: require('./pages/CloturerSollicitation').default,
                name: 'CloturerSollicitation',
                children: [
                    {
                        path: 'MotifsCloture',
                        component: require('./components/cloturersollicitation/Motif').default,
                        name: 'MotifsCloture',
                        props: (route) => ({
                            sollicitation: route.sollicitation
                        })
                    }
                ]
            }
        ]
    },
    {
        path: '/', component: require('./pages/Home').default, name: 'home',
        beforeEnter: mustBeAuthenticated
    },
    {path: '*', redirect: '/'}
]

export default new VueRouter({
    mode: 'history',
    routes
});
